import { z } from 'zod';
import { ProgrammeChoiceSchema } from '../applicant/index.js';

export const BaseRegistrationFormSchema = {
  intakeId: z.string().min(1, 'Intake is required'),
  studyLevel: z.string().min(1, 'Study level is required'),
  courseName: z.string().min(1, 'Course is required'),
  courseId: z.string().min(1, 'Course is required'),
  mode: z.string().min(1, 'Mode is required'),
  campus: z.string().min(1, 'Campus is required'),
  entryPoint: z.string().min(1, 'Entry year is required'),
  programmeChoices: z.array(ProgrammeChoiceSchema).optional(),
};
